import { fetchGetUserDataForUser } from '@/typescript/Services/Api/UserApi';
import SignalRService from '@/typescript/Services/SignalRService';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { defineStore } from 'pinia'
import { watch } from 'vue';
/**
 * 账号存储
 */
export const useUserStore = defineStore('user', {
    state: () => ({
        user: {} as DB.User
    }),
    getters: {
        getUser(state): DB.User {
            return state.user;
        },
        /**
         * 钱包可用余额
         * @param state 
         * @returns 
         */
        getAvailableBalance(state) {
            return (state.user.Balance ?? 0) - (state.user.BalanceLock ?? 0);
        },
        /**
         * 合约可用余额
         * @param state 
         * @returns 
         */
        getContractAvailableBalance(state) {
            return (state.user.ContractBalance ?? 0) - (state.user.ContractBalanceLock ?? 0);
        },
        /**
         * 现货可用余额
         * @param state 
         * @returns 
         */
        getSpotAvailableBalance(state) {
            return (state.user.SpotBalance ?? 0) - (state.user.SpotBalanceLock ?? 0);
        },
        /**
         * 期权可用余额
         * @param state 
         * @returns 
         */
        getOptionAvailableBalance(state) {
            return (state.user.OptionBalance ?? 0) - (state.user.OptionBalanceLock ?? 0);
        },
    },
    actions: {

        /**
         * 用户数据初始化
         */
        InitAsync() {
            watch(() => this.user.Uid, async (_nUid, _oUid) => {
                if (Tools.IsNotNull(_nUid)) {
                    Tools.ShowLog('UserStore', `发现账号变更:${_nUid}`);
                    await SignalRService.Instance.SendMessageAsync("BindUser", _nUid);

                } else if (Tools.IsNotNull(_oUid)) {
                    Tools.ShowLog("UserStore", `发现账号已退出登录:${_oUid}`);
                }
            }, {
                immediate: true
            });
        },

        /**
         * 退出登录
         */
        ToLogout() {
            Global.JwtToken = '';
            Global.RefreshToken = '';
            this.user = {};
            return true;
        },
        /**
         * 更新用户数据
         */
        async UpdateUserDataAsync() {
            const resp = await fetchGetUserDataForUser();
            if (resp.CheckIsOk(false)) {
                Object.assign(this.user, resp.data!);
            }
        }
    }
})
